import React, { useState } from "react";
import Sidebar from "./sidebar";
import Header from "./Header";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleMenuClick = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar} />
      <div className="main">
        <Header onMenuClick={handleMenuClick} />
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};


export default DashboardLayout;